import type { LegacyAtMeOutput } from 'korint-sdk';

export function hasBusinessRole(
  user: Pick<LegacyAtMeOutput, 'isSuperUser' | 'brokerRole' | 'relations'> | undefined,
  allowedRoles: ReadonlyArray<string>,
): boolean {
  if (!user) return false;
  if (user.isSuperUser) return true;
  const businessRole = user.brokerRole ?? user.relations?.[0]?.relationType;
  return businessRole !== undefined && allowedRoles.includes(businessRole);
}
